<div class="wizard-backdrop" *ngIf="isVisible" (click)="onCloseWizard()"></div>

<div class="document-upload-wizard-wrapper" *ngIf="isVisible" (click)="$event.stopPropagation()">
    <!-- Modal Container -->
    <div class="wizard-modal">
        <!-- Modal Header -->
        <div class="wizard-header">
            <h1>{{ wizardTitle }}</h1>
            <button type="button" class="close-btn" (click)="onCloseWizard()">
                <i class="fas fa-times"></i>
            </button>
        </div>

        <!-- Modal Body -->
        <div class="wizard-body">
            <!-- Upload Screen -->
            <div class="wizard-screen active">
                <!-- Document Type Selection -->
                <div class="form-group form-group-inline" *ngIf="documentTypes.length > 0">
                    <label for="document-type" class="form-label">Document Type <span class="required">*</span></label>
                    <div class="form-select-wrapper">
                        <ng-select id="document-type" [(ngModel)]="selectedDocumentType" [items]="documentTypes"
                            [bindLabel]="'name'" [bindValue]="'.'" (change)="onDocumentTypeChange($event)"
                            placeholder="Select document type" [disabled]="isLoading" [clearable]="false"
                            [searchable]="true" panelClass="wizard-dropdown-panel" [compareWith]="compareDocumentTypes">
                        </ng-select>
                    </div>
                </div>

                <!-- Description Text Box (Optional) -->
                <div class="form-group">
                    <label for="description" class="form-label">Description <span
                            class="optional">(Optional)</span></label>
                    <textarea id="description" [(ngModel)]="description"
                        placeholder="Enter any additional description or notes" class="form-textarea"
                        [disabled]="isLoading" rows="3">
                    </textarea>
                </div>

                <!-- File Upload Box -->
                <div class="upload-box-dark" (dragover)="onDragOver($event)" (dragleave)="onDragLeave($event)"
                    (drop)="onDrop($event)" [class.drag-over]="isDragOver">
                    <i class="fas fa-cloud-upload-alt fa-3x"></i>
                    <p>Drag and drop PDF or image, audio, video and dwg/cad files here</p>
                    <p class="upload-box-hint">or</p>
                    <label class="file-input-label">
                        <span>Click to browse files</span>
                        <input type="file" [attr.multiple]="multiFileAllowed ? '' : null" [accept]="acceptFileTypes"
                            (change)="onFileInputChange($event)" style="display: none;" [disabled]="isLoading">
                    </label>
                </div>

                <!-- Uploaded Files List -->
                <div id="upload-wizard-files-list" class="uploaded-files-container"></div>

                <!-- Modal Footer / Actions -->
                <div class="wizard-button-container">
                    <button type="button" class="btn btn-secondary" (click)="onCloseWizard()"
                        [disabled]="isLoading">
                        Cancel
                    </button>
                    <button type="button" class="btn btn-primary" (click)="finalizeUpload()"
                        [disabled]="!isUploadValid() || isLoading">
                        {{ isLoading ? 'Uploading...' : uploadButtonLabel }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
